import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import Can from '../../config/Can';
import Rest from "../../services/Rest";
const initialState = {
    error: false,
    errorMessage: ""
}
class Sidebar extends Component {

    constructor(props) {
        super(props);
        this.Can = new Can();
        this.Rest = new Rest();
        this.datauser = JSON.parse(localStorage.getItem("ls")) || [];
    }

    state = { ...initialState }

    exitApp = () => {
        this.Rest.get("autenticacion", this.datauser)
            .then(response => {
                if (response.status === 200) {
                    this.props.logout();
                }
                else {
                    if (response.status === 404) {
                        localStorage.removeItem('ls');
                        window.location = window.location.origin;
                    }
                    else {
                        if (response.status === 404) {
                            localStorage.removeItem('ls');
                            window.location = window.location.origin;
                        }
                        else {
                            this.setState({
                                error: true,
                                errorMessage: response.message
                            })
                        }
                    }
                }
            })
            .catch(err => {
                this.setState({
                    error: true,
                    errorMessage: JSON.stringify(err)
                })
            })
    }

    render() {
        const { error } = this.state
        return (

            <nav id="sidebar">
                {error ? <div className="alert alert-danger alert-float"></div> : null}
                <div className="sidebar-header">
                    <img src="/images/logo-sms-rapidos.jpeg" className="img-responsive img-navbar" alt="sms-rapidos" />

                </div>
                <ul className="list-unstyled components scroll-down">
                    <li className="active">
                        <Link to="/dashboard">
                            <i className="fas fa-home"></i> Resumen
                        </Link>
                    </li>
                    <li>
                        <a href="#submenuMensajes" data-toggle="collapse" role="button">
                            <i className="fas fa-envelope"></i> Mensajes <span><i className="fas fa-chevron-down"></i></span>
                        </a>
                        <ul className="list-unstyled components collapse" role="button" id="submenuMensajes">
                            <li>
                                <Link to="/mensajes-enviados">
                                    <i className="fas fa-paper-plane"></i> Mensajes enviados
                                </Link>
                            </li>
                            <li>
                                <Link to="/mensajes-recibidos">
                                    <i className="fas fa-envelope-open-text"></i> Mensajes recibidos
                                </Link>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <a href="#submenuCampañas" data-toggle="collapse" role="button">
                            <i className="fas fa-bullhorn"></i> Campañas <span><i className="fas fa-chevron-down"></i></span>
                        </a>
                        <ul className="list-unstyled components collapse" role="button" id="submenuCampañas">
                            <li>
                                <Link to="/campañas">
                                    <i className="fas fa-assistive-listening-systems"></i> Crear campaña
                                </Link>
                            </li>
                            <li>
                                <Link to="/lista-de-campañas">
                                    <i className="fas fa-list"></i> Lista de campañas
                                </Link>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a href="#submenuReportes" data-toggle="collapse" role="button">
                            <i className="fas fa-file-invoice"></i> Reportes <span><i className="fas fa-chevron-down"></i></span>
                        </a>
                        {this.Can.show(this.datauser.perm) ?
                            <ul className="list-unstyled components collapse" id="submenuReportes">
                                <Link to="/actividad-del-cliente"><i className="fas fa-chart-line"></i> Usuarios</Link>
                                <Link to="/consulta-de-campañas"><i className="fas fa-chart-line"></i> Campañas</Link>
                                <Link to="/consulta-de-saldos"><i className="fas fa-comment-dollar"></i> Saldos</Link>
                            </ul>
                            :
                            <ul className="list-unstyled components collapse" id="submenuReportes">
                                <Link to="/actividad-del-cliente"><i className="fas fa-chart-line"></i> Actividad</Link>
                            </ul>
                        }


                    </li>
                    {this.Can.show(this.datauser.perm) &&
                        <li>
                            <a href="#submenuUsuarios" data-toggle="collapse" role="button">
                                <i className="fas fa-users"></i> Usuarios <span><i className="fas fa-chevron-down"></i></span>
                            </a>
                            <ul className="list-unstyled components collapse" role="button" id="submenuUsuarios">
                                <li>
                                    <Link to="/lista-de-usuarios">
                                        <i className="fas fa-list"></i> Lista de usuarios
                            </Link>
                                </li>
                                <li>
                                    <Link to="/nuevo-usuario">
                                        <i className="fas fa-user-plus"></i> Agregar usuario
                            </Link>
                                </li>
                            </ul>
                        </li>
                    }
                    {this.Can.show(this.datauser.perm) &&
                        <li>
                            <a href="#submenuServidores" data-toggle="collapse" role="button">
                                <i className="fas fa-server"></i> Servidores <span><i className="fas fa-chevron-down"></i></span>
                            </a>
                            <ul className="list-unstyled components collapse" role="button" id="submenuServidores">
                                <li>
                                    <Link to="/servidores">
                                        <i className="fas fa-list"></i> Lista de servidores
                        </Link>
                                </li>
                                <li>
                                    <Link to="/nuevo-servidor">
                                        <i className="fas fa-plus"></i> Agregar servidor
                        </Link>
                                </li>
                            </ul>
                        </li>
                    }


                    <li>
                        <button type="button" className="btn" onClick={() => this.exitApp()}>
                            <i className="fas fa-sign-out-alt"></i> Salir
                            </button>
                    </li>
                </ul>
            </nav>
        );
    }
}

export default withRouter(Sidebar);


// WEBPACK FOOTER //
// ./src/components/navigation/Sidebar.js